export default () => {
  const hasSubBtns = document.querySelectorAll(".header__hasSub");

  if (hasSubBtns.length) {
    hasSubBtns.forEach(hasSub => {
      hasSub.addEventListener("click", (event) => {
        event.preventDefault();

        const subMenu = hasSub.nextElementSibling;

        if (subMenu && subMenu.classList.contains("header__sub")) {
          subMenu.classList.toggle("visible");

          if (subMenu.classList.contains("visible")) {
            subMenu.classList.remove("fadeOutSlide");
            subMenu.classList.add("fadeInSlide");
          } else {
            subMenu.classList.remove("fadeInSlide");
            subMenu.classList.add("fadeOutSlide");
            setTimeout(() => {
              subMenu.classList.remove("fadeOutSlide");
            }, 200);
          }
        }
      });
    });
  }
};
